import type {
  OrganizationVideoContentObjectDataObject,
  OrganizationVideoContentObjectListDataObject,
  VideoContentObjectDataObject,
  VideoContentObjectListDataObject,
} from 'models/service';
import { type VideoDetail, type VideoListItem, createVideoDetail, createVideoListItem } from 'models/video';
import {
  type OrganizationContentObjectDetail,
  createOrganizationContentObjectDetail,
} from '../contentable-type-content-objects';

export type VideoContentObject = OrganizationVideoContentObject;

export const createVideoContentObject = (data: VideoContentObjectDataObject): VideoContentObject =>
  createOrganizationVideoContentObject(data);

export type OrganizationVideoContentObject = {
  type: 'video';
  video: VideoDetail;
} & OrganizationContentObjectDetail;

export const createOrganizationVideoContentObject = (
  data: OrganizationVideoContentObjectDataObject,
): OrganizationVideoContentObject => ({
  ...createOrganizationContentObjectDetail(data),
  type: 'video',
  video: createVideoDetail(data.video),
});

export type VideoContentObjectList = OrganizationVideoContentObjectList;

export const createVideoContentObjectList = (data: VideoContentObjectListDataObject): VideoContentObjectList =>
  createOrganizationVideoContentObjectList(data);

export type OrganizationVideoContentObjectList = {
  type: 'video';
  video: VideoListItem;
} & OrganizationContentObjectDetail;

export const createOrganizationVideoContentObjectList = (
  data: OrganizationVideoContentObjectListDataObject,
): OrganizationVideoContentObjectList => ({
  ...createOrganizationContentObjectDetail(data),
  type: 'video',
  video: createVideoListItem(data.video),
});
